module.exports = __webpack_public_path__ + "img/1f629.907d46b.svg";